.container {
  padding: 2rem;
  opacity: 0.6;
  pointer-events: none;
  filter: blur(2px);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.title {
  font-size: 32px;
  font-weight: 600;
  color: var(--static-text-strong);
  margin: 0;
}

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1rem;
  margin-bottom: 2rem;
}

.cardHeight {
  height: auto;
}

.tableContainer {
  width: 100%;
}

.searchInput {
  width: 100%;
  max-width: 400px;
}

.imageButton {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: default;
}

.image {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 4px;
}

.productCell {
  display: flex;
  align-items: center;
  text-align: left;
}

.rightAlign {
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}